// @ts-nocheck
import React, { useEffect, useMemo, useState } from 'react';
import {
  useLocation,
  useParams,
} from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/24/outline';

import Multibanco from '../../components/successPage/Multibanco';
import CC from '../../components/successPage/CC';
import MBWay from '../../components/successPage/MBWay';
import CashPayment from '../../components/successPage/CashPayment';

import euforms from '../../images/euforms.png';
import { useI18n } from '../../i18n/I18nContext';
import { PUBLIC_LANGUAGE_SESSION_KEY, normalizeLanguage } from '../../i18n/translations';
import { URL } from '../../service/Service';
import { getThemeStyle } from '../../config/formThemes';

const GenericSuccess = () => (
    <div className="min-h-screen overflow-x-hidden bg-slate-50">
      <nav className="flex items-center bg-green-cl p-6">
        <img
            className="h-8"
            src={euforms}
            alt="Eupago"
        />
      </nav>

      <main className="mx-auto flex max-w-3xl flex-col items-center px-5 py-20 text-center">
        <div className="w-full rounded-3xl border border-slate-200 bg-white p-10 shadow-sm">
          <CheckCircleIcon className="mx-auto h-20 w-20 text-emerald-600" />

          <h1 className="mt-6 text-3xl font-bold text-slate-950">
            Formulário enviado com sucesso
          </h1>

          <p className="mt-3 text-slate-600">
            A sua resposta foi registada.
            Pode fechar esta página em segurança.
          </p>
        </div>
      </main>
    </div>
);

const FormSuccess = () => {
  const location = useLocation();
  const { method } = useParams();
  const { setLanguage } = useI18n();
  const [formAppearance, setFormAppearance] = useState({
    theme: 'EUPAGO',
    customThemeColor: null,
    customThemeBase: 'LIGHT',
  });

  const formId = useMemo(() => (
    location.state?.formId
    || location.state?.paymentinfo?.formID
    || location.state?.paymentinfo?.formId
    || new URLSearchParams(location.search).get('formId')
  ), [location.search, location.state]);

  useEffect(() => {
    const publicLanguage = sessionStorage.getItem(PUBLIC_LANGUAGE_SESSION_KEY);
    if (publicLanguage) {
      setLanguage(normalizeLanguage(publicLanguage, 'EN'), false);
    }
  }, [setLanguage]);

  useEffect(() => {
    if (!formId) return;
    let active = true;

    const browserLanguage = Array.isArray(navigator.languages) && navigator.languages.length > 0
      ? navigator.languages.join(',')
      : navigator.language || '';

    const formRequest = fetch(`${URL}/api/public/forms/${encodeURIComponent(formId)}`, {
      headers: { Accept: 'application/json' },
    }).then((response) => response.ok ? response.json() : null);

    const languageRequest = fetch(
      `${URL}/api/public/forms/${encodeURIComponent(formId)}/language?browserLanguage=${encodeURIComponent(browserLanguage)}`,
      { headers: { Accept: 'application/json' } },
    ).then((response) => response.ok ? response.json() : null);

    Promise.allSettled([formRequest, languageRequest]).then(([formResult, languageResult]) => {
      if (!active) return;

      const form = formResult.status === 'fulfilled' ? formResult.value : null;
      if (form) {
        setFormAppearance({
          theme: form.theme || 'EUPAGO',
          customThemeColor: form.customThemeColor || null,
          customThemeBase: form.customThemeBase || 'LIGHT',
        });
      }

      const payload = languageResult.status === 'fulfilled' ? languageResult.value : null;
      const configuredLanguage = String(form?.language || '').toUpperCase();
      const browserPrefix = browserLanguage.trim().slice(0, 2).toUpperCase();
      const fallbackLanguage = ['PT', 'ES', 'EN'].includes(configuredLanguage)
        ? configuredLanguage
        : (['PT', 'ES', 'EN'].includes(browserPrefix) ? browserPrefix : 'EN');
      const resolvedLanguage = normalizeLanguage(payload?.language, normalizeLanguage(fallbackLanguage, 'EN'));

      sessionStorage.setItem(PUBLIC_LANGUAGE_SESSION_KEY, resolvedLanguage);
      setLanguage(resolvedLanguage, false);
    });

    return () => { active = false; };
  }, [formId, setLanguage]);

  const paymentinfo =
      location.state?.paymentinfo;

  let content;

  switch (method) {
    case 'mb':
      content = paymentinfo ? (
          <Multibanco
              paymentinfo={paymentinfo}
          />
      ) : (
          <GenericSuccess />
      );
      break;

    case 'cc':
      content = <CC />;
      break;

    case 'mbw':
      content = paymentinfo ? (
          <MBWay
              paymentinfo={paymentinfo}
          />
      ) : (
          <GenericSuccess />
      );
      break;

    case 'googlepay':
    case 'applepay':
      content = <CC />;
      break;

    case 'cashpayment':
      content = paymentinfo ? (
          <CashPayment
              paymentinfo={paymentinfo}
          />
      ) : (
          <GenericSuccess />
      );
      break;

    default:
      content = <GenericSuccess />;
  }

  return (
    <div
      className="form-theme-root form-success-page min-h-screen"
      data-form-theme={formAppearance.theme}
      style={getThemeStyle(
        formAppearance.theme,
        formAppearance.customThemeColor,
        formAppearance.customThemeBase,
      )}
    >
      <div className="public-form-workspace min-h-screen">{content}</div>
    </div>
  );
};

export default FormSuccess;
